import { addEvent, addClass, removeClass } from "@qneyraud/q-utils";
import gsap from "gsap";
import Bus from "@lib/helpers/event-bus.js";

export default class Slider {
  /**
   * @param {Object} obj - Slider options
   * @param {Array} obj.items - An array of slider items
   * @param {HTMLElement} obj.prevButton - Reference to the previous button
   * @param {HTMLElement} obj.nextButton - Reference to the next button
   * @param {(Number|Function)} obj.itemsPerPage - Items per page or a function returning this number
   */
  constructor({ items, prevButton, nextButton, itemsPerPage } = {}) {
    this.items = items;
    this.prevButton = prevButton;
    this.nextButton = nextButton;
    this.itemsPerPageCallback = itemsPerPage;

    this.currentPageIndex = 0;
    this.prevButtonActive = false;
    this.nextButtonActive = true;
    this.itemsPerPage = this.getItemsPerPage();
    this.totalPages = this.getTotalPages();

    this.bindMethods();
    this.initEvents();
    this.updateNextButtonState();
    this.updatePrevButtonState();
    Bus.on("resize-debounced", this.onResize);
  }

  bindMethods() {
    this.onPrevButtonClick = this.onPrevButtonClick.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  initEvents() {
    addEvent(this.prevButton, "click", this.onPrevButtonClick);
    addEvent(this.nextButton, "click", this.onNextButtonClick);
  }

  destroy() {
    Bus.off("resize-debounced", this.onResize);
  }

  onResize() {
    this.itemsPerPage = this.getItemsPerPage();
    this.totalPages = this.getTotalPages();

    this.currentPageIndex = 0;
    this.goToPage(0);
  }

  onPrevButtonClick() {
    if (!this.prevButtonActive) return;
    this.goToPage(this.currentPageIndex - 1);
  }

  onNextButtonClick() {
    if (!this.nextButtonActive) return;
    this.goToPage(this.currentPageIndex + 1);
  }

  getItemsPerPage() {
    if (typeof this.itemsPerPageCallback === "number") return this.itemsPerPageCallback;
    if (typeof this.itemsPerPageCallback === "function") return this.itemsPerPageCallback();

    return 1;
  }

  getTotalPages() {
    return Math.ceil(this.items.length / this.itemsPerPage);
  }

  updatePrevButtonState() {
    if (this.currentPageIndex === 0) {
      addClass(this.prevButton, "inactive");
      this.prevButtonActive = false;
    } else {
      removeClass(this.prevButton, "inactive");
      this.prevButtonActive = true;
    }
  }

  updateNextButtonState() {
    if (this.currentPageIndex === this.totalPages - 1) {
      addClass(this.nextButton, "inactive");
      this.nextButtonActive = false;
    } else {
      removeClass(this.nextButton, "inactive");
      this.nextButtonActive = true;
    }
  }

  goToPage(pageIndex) {
    let from = pageIndex > this.currentPageIndex ? 0 : this.items.length - 1;

    this.currentPageIndex = pageIndex;

    gsap.to(this.items, {
      duration: 0.1 * this.items.length,
      ease: "power2.inOut",
      stagger: {
        amount: 0.25,
        from
      },
      x: this.currentPageIndex * 100 * this.itemsPerPage * -1 + "%"
    });

    this.updatePrevButtonState();
    this.updateNextButtonState();
  }
}



// WEBPACK FOOTER //
// ./scripts/helpers/slider.js